var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container",staticStyle:{"width":"1300px","margin":"6px auto"}},[_c('iframe',{ref:"iframe",staticStyle:{"border-radius":"16px","box-shadow":"0 4px 12px rgba(0,0,0,0.1)","background-color":"#fff"},attrs:{"src":"http://119.45.200.53:4567/","width":"100%","frameborder":"0","height":"800px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }